import { render } from "./FormRelMany.vue?vue&type=template&id=055da898"
import script from "./FormRelMany.vue?vue&type=script&lang=js"
export * from "./FormRelMany.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelMany.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "055da898"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('055da898', __exports__)) {
    console.log('reload')
    api.reload('055da898', __exports__)
  }
  
  module.hot.accept("./FormRelMany.vue?vue&type=template&id=055da898", () => {
    console.log('re-render')
    api.rerender('055da898', render)
  })

}


export default __exports__